'use strict';

if (!require('./is-implemented')()) {
	Object.defineProperty(require('es5-ext/global'), 'Symbol',
		{ value: require('./polyfill'), configurable: true, enumerable: false,
			writable: true });
}



//////////////////
// WEBPACK FOOTER
// ../es6-symbol/implement.js
// module id = 233
// module chunks = 1